import React from "react";
import useTheme from "../../../../hooks/useTheme";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  getUserName,
  formatMemberSinceDate,
  getContactPersonProfilePath,
} from "../../../../utils/helperFunctions";
import { UserAvatar } from "../../../UI/DisplayImage";
import { AppColumn } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import { closeModal } from "../../../../redux/Modals/ModalActions";
import { t } from "i18next";
import { Icon } from "semantic-ui-react";

const ContactPersonProfileSheet = ({ contactPerson }) => {
    const theme = useTheme();
  const dispatch = useDispatch();
  const name = getUserName(contactPerson);
  const workplaceName = contactPerson?.workplaceName ?? "";

  const introText = contactPerson?.introField || contactPerson?.aboutText;

  const memberSinceFormatted = formatMemberSinceDate(contactPerson?.memberSince);
  const profilePath = getContactPersonProfilePath(contactPerson);

  return (
    <div style={{ position: "relative", padding: theme.spacing.contentElementPadding }}>
      <div
        onClick={() => dispatch(closeModal())}
        style={{
          position: "absolute",
          top: theme.spacing.elementPadding,
          right: theme.spacing.elementPadding,
          cursor: "pointer",
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.colors.lightGrey,
          transition: "background-color 0.15s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#d4d4d4")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.colors.lightGrey)}
      >
        <Icon
          name="close"
          style={{
            margin: 0,
            fontSize: "12px",
            color: theme.colors.dark,
          }}
        />
      </div>

      <AppColumn crossAxisAlignment={"center"} style={{ textAlign: "center" }}>
        <SizedBox height={theme.spacing.elementPaddingSmall} />

        <UserAvatar
          url={contactPerson?.profileImageUrl}
          name={name}
          style={{
            aspectRatio: "1",
            height: "96px",
            width: "96px",
          }}
        />

        <SizedBox height={theme.spacing.elementPadding} />

        <AppText.SubHeading fontWeight={600}>{name}</AppText.SubHeading>

        {workplaceName && (
          <>
            <SizedBox height={"0.15rem"} />
            <AppText.Caption color={theme.colors.dark}>
              {workplaceName}
            </AppText.Caption>
          </>
        )}

        {memberSinceFormatted && (
          <>
            <SizedBox height={"0.15rem"} />
            <AppText.Footnote color={theme.colors.grey}>
              {t("contact_person.member_since", { date: memberSinceFormatted, appName: theme.appName })}
            </AppText.Footnote>
          </>
        )}

        {introText && (
          <>
            <SizedBox height={theme.spacing.contentElementPadding} />
            <div
              style={{
                width: "100%",
                height: "1px",
                backgroundColor: theme.colors.lightGrey,
              }}
            />
            <SizedBox height={theme.spacing.contentElementPadding} />
            <AppText.Caption
              fontWeight={600}
              style={{ textAlign: "left", width: "100%" }}
            >
              {t("contact_person.about_me")}
            </AppText.Caption>
            <SizedBox height={theme.spacing.elementPaddingSmall} />
            <AppText.Footnote
              color={theme.colors.dark}
              style={{
                textAlign: "left",
                width: "100%",
                lineHeight: "1.6",
              }}
            >
              {introText}
            </AppText.Footnote>
          </>
        )}

        {/* Link to the full profile only after the contact person opts in. */}
        {profilePath && (
          <>
            <SizedBox height={theme.spacing.elementPadding} />
            <Link
              to={profilePath}
              onClick={() => dispatch(closeModal())}
              style={{ color: theme.primaryColor, textDecoration: "underline" }}
            >
              <AppText.Caption color={theme.primaryColor} fontWeight={600}>
                {t("contact_person.view_full_profile")}
              </AppText.Caption>
            </Link>
          </>
        )}

        <SizedBox height={theme.spacing.elementPadding} />
      </AppColumn>
    </div>
  );
};

export default ContactPersonProfileSheet;
